<template>
  <div class="bgf2f2f2 min_width">
    <div>
      <!-- <div class="fixedTop"> -->
      <div class="dp-bg-top">
        <div class="tr m0a main_width cfff f14 hl25 fSpace">
          <div>
            <p class="df aic">
              <Icon class="va-4" type="ios-call" size=22 />
              4000-963-100
            </p>
          </div>
          <div class="fEnd main_top_nav">
            <!-- <router-link class="mr30 cfff df aic h100b" to="/Information">
              <svg-icon class="mr5 f19" icon-class="rzline-hyzx"></svg-icon>行业资讯
            </router-link> -->

            <p ref="main_customer" class="cp cfff mr30 df aic h100b" @click="handleCustomerBtn()">
              <svg-icon class="mr5 f19" icon-class="rzline-Call_Center"></svg-icon>客服服务
            </p>

            <router-link class="mr30 cfff df aic h100b" to="/PlatformIntroduce">
              <svg-icon class="mr5 f19" icon-class="rzline-description"></svg-icon>产品介绍
            </router-link>
            <router-link class="mr30 cfff df aic h100b" to="/download">
              <svg-icon class="mr5 f19" icon-class="iphone1"></svg-icon>APP下载
            </router-link>

            <router-link class="mr30 cfff df aic h100b" to="/Help">
              <Icon class="mr3" size=22 color="#fff" type="ios-help-buoy-outline" />帮助中心
            </router-link>

            <span v-if="$store.state.userId" class="cp" @click="exitLoginEvent">退出登录</span>
            <span v-else @click="showLoginPopus()" class="cp">立即登录</span>
          </div>
        </div>
      </div>
      <div class="bgfff bs31">
        <div class="main_width h80 fSpace m0a">
          <!-- logo -->
          <div class="df aic jcc">
            <router-link to="/"><img src="~@/assets/img/home/logo@2x.png" alt="" class="logo h33 mr11 dl vam bimginitial bscontain"></router-link>
            <span class="f24 c333 fb mr30 dn">{{$store.state.webInfo.platformName}}</span>
            <span class="c333 f19 dn">{{$store.state.webInfo.platformTitle}}</span>
          </div>

          <!-- 导航 -->
          <Nav />
        </div>
      </div>
    </div>

    <router-view v-if="isRouterAlive" />

    <!--底部-->
    <Bottom />

    <!--公共的弹框-->
    <div class="popups_style popupsEvent" v-if="$store.state.showPopups" @click="hidePopusClick()">
      <!--为了阻止浏览器自动填充-->
      <input type="password" class="hide" id="loginPassword" readonly />
      <input type="text" class="hide" id="loginUserName" readonly />

      <!--立即登录的弹框-->
      <div class="login_alert df" v-if="$store.state.loginStatus">
        <!--关闭按钮-->
        <Icon type="md-close close_style" class="f24 c999 cp" @click="close_popups()" />
        <div class="w336 login_alert_left p20 login_logo">
          <!--<div class="f30 cfff tl">立即登录</div>
          <div class="f48 cfff fb tl">快贴宝</div>-->
        </div>
        <div class="f1 pt20 pb20 plr54">
          <template v-if="loginParam.currentStatus=='login'">
            <div class="fb f24 dp-c-primary l24 mt15">立即登录</div>
            <div class="tc bbFFAFAF dl l38 mt15">
              <span class="w130 tc dl f16 mr8" :class="[loginParam.currentTab==2?'c333 cp fb':'bbinitial dp-bc-tab-active dp-c-tab-active bw2 cp']" @click="chooseTab(1)">手机号快捷登录</span>
              <span style="width: 2px; height: 14px;" class="bge9e9e9 dl vam"></span>
              <span class="w130 tc dl f16 ml8" :class="[loginParam.currentTab==1?'c333 cp fb':'bbinitial dp-bc-tab-active dp-c-tab-active bw2 cp']" @click="chooseTab(2)">账号密码登录</span>
            </div>
            <template v-if="loginParam.currentTab==1">
              <div class="c333 f14 mt20">如您是“融资线”用户，无需注册直接登录</div>
              <div class="df dp-bc-primary bb666 aic jcc mt52 mb20 pb1">
                <span class="c999 f16 fn">手机号</span>
                <Input v-model="loginParam.phone" placeholder="请输入您的手机号" type="tel" maxlength="11" />
              </div>
              <div class="df dp-bc-primary bb666 aic jcc pb1">
                <span class="c999 f16 fn">验证码</span>
                <Input v-model="loginParam.code" placeholder="请输入短信验证码" maxlength="6" @on-enter="loginEvent" />
                <span class="fn f14 dp-c-primary-text cp" @click="getCaptcha">{{smsCaptcha.text}}</span>
              </div>
            </template>
            <template v-else>
              <div class="df dp-bc-primary bb666 aic jcc mt49 mb16 pb1">
                <span class="c999 f16 fn">手机号</span>
                <Input v-model="loginParam.phone" placeholder="请输入您的手机号" type="tel" maxlength="11" />
              </div>
              <div class="df dp-bc-primary bb666 aic jcc pb1">
                <span class="c999 f16 fn">密码</span>
                <Input v-model="loginParam.password" type="password" placeholder="请输入6位数字密码" maxlength="6" v-number-only @on-blur="blurPass" @on-enter="loginEvent" />
                <span class="fn f14 dp-c-primary-text cp" @click="changeCurrentStatus('forget')">忘记密码</span>
              </div>
            </template>
            <div class="df aic jcc mt78 mb40">
              <Button type="default" shape="circle" class="bg-gradient mr20 w136 f16 hl46 p0" @click="loginEvent">登录</Button>
              <span class="f14 c333">暂无账号?</span>
              <span class="f14 dp-c-primary-text cp" @click="changeCurrentStatus('register')">立即注册</span>
            </div>
          </template>
          <template v-else-if="loginParam.currentStatus=='forget'">
            <div class="dp-c-primary-title f16 fb mb18">忘记密码</div>
            <div class="df dp-bc-primary bb666 aic jcc mb20 pb2">
              <span class="c999 f16 fn">手机号</span>
              <Input v-model="loginParam.phone" placeholder="请输入您的手机号" type="tel" maxlength="11" />
            </div>
            <div class="df dp-bc-primary bb666 aic jcc mb30 pb2">
              <span class="c999 f16 fn">验证码</span>
              <Input v-model="loginParam.forgetParam.captcha" placeholder="请输入短信验证码" maxlength="6" />
              <span class="fn f14 dp-c-primary-text cp" @click="getCaptcha">{{smsCaptcha.text}}</span>
            </div>
            <div class="tl c333 f12 mb15">设置新密码</div>
            <div class="df dp-bc-primary bb666 aic jcc mb30 pb2">
              <span class="c999 f16 fn">设置密码</span>
              <Input v-number-only @on-blur="blurPass" v-model="loginParam.forgetParam.password" maxlength="6" type="password" placeholder="登录密码为六位数字" />
            </div>
            <div class="df dp-bc-primary bb666 aic jcc mb30 pb2">
              <span class="c999 f16 fn">重复输入</span>
              <Input v-number-only @on-blur="blurPass" v-model="loginParam.forgetParam.rePassword" maxlength="6" type="password" placeholder="登录密码为六位" />
            </div>
            <div class="df aic jcc">
              <Button type="default" shape="circle" class="bg-gradient mr15 w180 hl46 p0 f16" @click="resetPassword">确定</Button>
              <span class="dp-c-primary-text cp bbinitial dp-bc-primary f14" @click="changeCurrentStatus('login')">
                <Icon size="16" type="md-return-left" />返回登录
              </span>
            </div>
          </template>
          <template v-else-if="loginParam.currentStatus=='register'">
            <div class="dp-c-primary-title f16 fb mb18">立即注册</div>
            <div class="tl c666 f12 mb3 mb15">1.手机号验证，您的登录账号即为您的手机号</div>
            <div class="df dp-bc-primary bb666 aic jcc mb20 pb2">
              <span class="c999 f16 fn">手机号</span>
              <Input v-model="loginParam.phone" placeholder="请输入您的手机号" type="tel" maxlength="11" />
            </div>
            <div class="df dp-bc-primary bb666 aic jcc mb30 pb2">
              <span class="c999 f16 fn">验证码</span>
              <Input v-model="loginParam.registerParam.captcha" placeholder="请输入短信验证码" maxlength="6" />
              <span class="fn f14 dp-c-primary-text cp" @click="getCaptcha">{{smsCaptcha.text}}</span>
            </div>
            <div class="tl c333 f12 mb15">2.设置登录密码</div>
            <div class="df dp-bc-primary bb666 aic jcc mb30 pb2">
              <span class="c999 f16 fn">设置密码</span>
              <Input v-number-only @on-blur="blurPass" v-model="loginParam.registerParam.password" maxlength="6" placeholder="登录密码为6位数字组合" type="password" />
            </div>
            <div class="df dp-bc-primary bb666 aic jcc mb30 pb2">
              <span class="c999 f16 fn">重复输入</span>
              <Input v-number-only @on-blur="blurPass" v-model="loginParam.registerParam.rePassword" maxlength="6" placeholder="登录密码为6位数字组合" type="password" />
            </div>
            <div class="df aic jcc">
              <Button type="default" shape="circle" class="bg-gradient mr15 w180 hl46 p0 f16" @click="registerEvent()">立即注册</Button>
              <span class="dp-c-primary-text cp bbinitial dp-bc-primary f14" @click="changeCurrentStatus('login')">
                <Icon size="16" type="md-return-left" />返回登录
              </span>
            </div>
          </template>
          <template v-else-if="loginParam.currentStatus=='loading'">
            <div class="df aic jcc fDC w100b h100b">
              <div class="head_img wh86 mb15" :style="{'backgroundImage': 'url(' + headImage() + ')'}"></div>
              <div class="f14 c333 mb40">欢迎登录</div>
              <div class="f14 c666">登录中</div>
            </div>
          </template>
        </div>
      </div>

      <!--公共的提示框-->
      <div class="tip df fDC aic jcc pb40 bgfff pac mw560 br5 oh" v-if="$store.state.tipStatus">
        <!--关闭按钮-->
        <Icon v-if="!$store.state.tipContent.hideClose" type="ios-close close_style" class="f36 c999 cp t4 r0 hoverOpacity" :class="$store.state.tipContent.closeStyle" @click="close_popups($store.state.tipContent.closeCallback)" />

        <div class="f18 cfff dp-bg-primary w100b l44">{{$store.state.tipContent.title}}</div>

        <div v-if="$store.state.tipContent.tipLogo" class="tip_img wh92 mt67" :class="$store.state.tipContent.tipLogo"></div>

        <div :class="$store.state.tipContent.tipClass || 'mb80 mt20'" v-html="$store.state.tipContent.tipMessage"></div>

        <div class="df aic jcc">
          <Button v-if="$store.state.tipContent.tipButtonLeft" :type="$store.state.tipContent.tipButtonLeftType" :class="$store.state.tipContent.tipButtonLeftClass ? $store.state.tipContent.tipButtonLeftClass : 'f14'" @click="$store.state.tipContent.tipButtonLeftCall()">{{$store.state.tipContent.tipButtonLeft}}</Button>

          <Button v-if="$store.state.tipContent.tipButtonRight" :type="$store.state.tipContent.tipButtonRightType" :class="$store.state.tipContent.tipButtonRightClass ? $store.state.tipContent.tipButtonRightClass : 'ml40 f14'" @click="$store.state.tipContent.tipButtonRightCall()">{{$store.state.tipContent.tipButtonRight}}</Button>
        </div>
        <div class="bottom" v-if="$store.state.tipContent.bottom" @click="$store.state.tipContent.bottomCall()" v-html="$store.state.tipContent.bottom"></div>
      </div>

      <!--红包弹框-新用户-->
      <transition name="red-packet">
        <div class="red_packet" v-show="$store.state.redStatus">
          <transition name="draw-up">
            <div class="draw-up" v-if="$store.state.drawUpStatus" @click.stop="">
              <div class="draw-slow-up">
                <div class="f24 c2e2e2e mt100 mb10">恭喜您，获得红包</div>
                <div class="cE56750 fb"><span class="f30">¥</span><span class="f54 l54">{{$store.state.redAmount}}</span></div>
                <div class="f19 cE56750">服务费</div>
              </div>
            </div>
          </transition>
          <transition name="draw-down">
            <div class="draw-down" v-if="$store.state.drawDownStatus" @click.stop=""></div>
          </transition>
          <div class="bottom" @click.stop="">
            <div class="red_bottom">
              <transition name="red-button">
                <Button @click="toServiceDetail" class="search_red" v-if="$store.state.drawUpStatus">
                  <svg-icon class="va-4 mr12 f26" icon-class="View"></svg-icon>立即查看
                </Button>
              </transition>
            </div>
          </div>
        </div>
      </transition>

      <!--红包弹框-老用户-->
      <transition name="red-packet">
        <div class="red_packet" v-show="$store.state.redOldStatus">
          <transition name="draw-up">
            <div class="draw-up draw-up-old" v-if="$store.state.drawUpOldStatus" @click.stop="">
              <div class="draw-slow-up draw-slow-up-old">
                <div class="f24 c2e2e2e mt100 mb10">恭喜您，获得红包</div>
                <div class="cE56750 fb"><span class="f30">¥</span><span class="f54 l54">{{$store.state.redAmount}}</span></div>
                <div class="f19 cE56750">服务费</div>
              </div>
            </div>
          </transition>
          <transition name="draw-down">
            <div class="draw-down draw-down-old" v-if="$store.state.drawDownOldStatus" @click.stop=""></div>
          </transition>
          <div class="bottom bottom-old" @click.stop="">
            <div class="down_bottom" v-if="!$store.state.drawUpOldStatus">
              <div class="click_btn open-face-enter-active" @click="getOldRed" v-if="!$store.state.drawUpOldStatus">拆</div>
              <div class="f24 cfff mb14 plr20 maxw100b">{{$store.state.redContent}}</div>
              <div class="f24 cfff">您有一个红包待领取</div>
            </div>
            <div class="red_bottom">
              <transition name="red-button">
                <Button @click="toServiceDetail" class="search_red bgE56750 cFFE2B1" v-if="$store.state.drawUpOldStatus">
                  <svg-icon class="va-4 mr12 f26" icon-class="View_y"></svg-icon>立即查看
                </Button>
              </transition>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!--网易易盾专用-->
    <remote-js :js-url="'https://cstaticdun.126.net/load.min.js'" :js-load-call-back="NECaptchaJsOnLoad"></remote-js>
    <div id="captcha"></div>

    <!-- 客服 -->
    <div class="main_custom fEnd cfff fDC">
      <span class="bb1666AB left_tip left_tip_line" @click="bankNumSearch">
        <svg-icon class="f20 va-6" icon-class="icon_hanghaochaxun"></svg-icon>
      </span>
      <span class="bb1666AB left_tip left_tip_trial" @click="discountTrial">
        <svg-icon class="f20 va-6" icon-class="icon_jisuanqi"></svg-icon>
      </span>
      <Badge :count="$store.state.eventCount" class-name="ivu-badge-count_n">
        <span class="bb1666AB left_tip left_tip_backlog" @click="routerTo('DiscountTrends')">
          <svg-icon class="f20 va-6" icon-class="Bell"></svg-icon>
        </span>
      </Badge>

      <Badge :count="$store.state.orderCount" class-name="ivu-badge-count_n">
        <span class="bb1666AB left_tip left_tip_ordering" @click="routerTo('order')">
          <svg-icon class="f20 va-6" icon-class="File"></svg-icon>
        </span>
      </Badge>

      <span class="left_tip left_tip_customer" @click="handleCustomerBtn()">
        <svg-icon class="f20 va-6" icon-class="rzline-headset"></svg-icon>
      </span>
    </div>

    <!-- 红包 -->
    <div class="red_packet_small" @click="showOldRed" v-if="$store.state.redType == 2 && !$store.state.redOldStatus">
      <span class="f14 cfff pa w100b left0 b3">老用户福利</span>
    </div>

    <CommonDiscountTrial ref="CommonDiscountTrial"></CommonDiscountTrial>
    <CommonBankNumSearch ref="CommonBankNumSearch"></CommonBankNumSearch>
  </div>
</template>

<script>
import store from '@/store/store';
// 引入组件
import Nav from './module/Nav.vue';
import Bottom from './module/Bottom.vue';
import RemoteJs from './module/RemoteJs';
import CommonDiscountTrial from './common/CommonDiscountTrial'
import CommonBankNumSearch from './common/CommonBankNumSearch'

let _this;

export default {
  store, // 引用

  components: {
    Nav, // 侧边栏
    Bottom, // 底部
    RemoteJs,
    CommonDiscountTrial,
    CommonBankNumSearch
  },

  data () {
    return {
      isRouterAlive: true,

      loginParam: {
        // 当前选项
        currentTab: 1,
        phone: "", // 手机号码
        code: "", // 验证码
        password: "", // 验证码
        currentStatus: "login", // 忘记密码:forget;注册：register；登录：login;正在登录中：loading
        // 注册参数
        registerParam: {
          password: "", // 密码
          rePassword: "", // 重复密码
          captcha: "", // 短信验证码
        },
        // 忘记密码参数
        forgetParam: {
          password: "", // 密码
          rePassword: "", // 重复密码
          captcha: "", // 短信验证码
        }
      },
      smsCaptcha: {
        text: '获取验证码',
        enableClick: true,
        data: {}
      }, // 短信验证码
    };
  },
  provide () {
    return {
      reload: this.reload
    }
  },

  methods: {
    discountTrial () {
      this.$refs.CommonDiscountTrial.show()
    },
    bankNumSearch () {
      this.$refs.CommonBankNumSearch.show()
    },

    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    // 网易易盾验证码初始化
    NECaptchaJsOnLoad () {
      let self = this;
      initNECaptcha({
        element: '#captcha',
        captchaId: '6be3a8a431b94be3a924ee0aa3213882',
        mode: 'popup',
        width: '320px',
        // enableClose: true, // 由业务方控制验证码弹框关闭
        // feedbackEnable: false, // 业务方关闭反馈入口
        onClose: function () {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function (err, data) {
          if (err) return;
          self.smsCaptcha.data.validate = data.validate;
          self.sendSmsCaptcha();
        }
      }, function (instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        self.captchaIns = instance
      }, function (err) {
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    },
    // 获取验证码
    getCaptcha: function () {
      console.log(this.smsCaptcha.enableClick)
      if (!this.verifyMobile(this.loginParam.phone)) return;
      if (!this.smsCaptcha.enableClick) return;
      this.captchaIns && this.captchaIns.refresh();
      this.captchaIns && this.captchaIns.popUp();
      // this.captchaIns && this.captchaIns.refresh();
    },
    // 发送短信验证码
    sendSmsCaptcha () {
      this.smsCaptcha.enableClick = false;
      this.smsCaptcha.data.phoneNumber = this.loginParam.phone;
      let requestPath = "/web/mobuser/reg/smsSendWithNECaptcha";
      if (this.loginParam.currentStatus == 'login') {
        this.smsCaptcha.data.type = '5'
      } else if (this.loginParam.currentStatus == 'register') {
        this.smsCaptcha.data.type = '1'
      } else if (this.loginParam.currentStatus == 'forget') {
        this.smsCaptcha.data.type = '3';
        requestPath = "/web/mobuser/reg/forget";
      }
      let self = this;
      this.sendOther({
        url: requestPath,
        data: this.smsCaptcha.data
      }, (result) => {
        this.$Message.success("发送成功");
        // 60s短信倒计时
        let number = 60;
        this.captchaTimer = setInterval(function () {
          number--;
          self.smsCaptcha.text = "重新获取" + number + "s";
          if (number == 0) {
            self.smsCaptcha.text = "获取验证码";
            self.smsCaptcha.enableClick = true;
            clearInterval(self.captchaTimer)
          }
        }, 1000)
      }, (result) => {
        self.smsCaptcha.enableClick = true;
      })
    },
    // 公共的关闭弹框
    close_popups: function (closeCallback) {
      // 初始化密码框参数
      this.loginParam = {
        // 当前选项
        currentTab: 1,
        phone: "", // 手机号码
        code: "", // 验证码
        password: "", // 验证码
        currentStatus: "login", // 忘记密码:forget;注册：register；登录：login;
        // 注册参数
        registerParam: {
          password: "", // 密码
          rePassword: "", // 重复密码
          captcha: "", // 短信验证码
        },
        // 忘记密码参数
        forgetParam: {
          password: "", // 密码
          rePassword: "", // 重复密码
          captcha: "", // 短信验证码
        }
      }
      // 如果有定时器则清除
      this.captchaTimer ? clearInterval(this.captchaTimer) : "";
      this.smsCaptcha.text = "获取验证码";
      this.smsCaptcha.enableClick = true;
      this.$store.state.showPopups = false;
      this.$store.state.loginStatus = false;
      closeCallback ? closeCallback() : "";
    },
    // 切换登录选择框
    chooseTab: function (val) {
      this.loginParam.currentTab = val;
    },
    // 返回登录
    changeCurrentStatus: function (val) {
      this.loginParam.currentStatus = val;
    },
    // 登录接口调用
    loginEvent: function () {
      if (!this.verifyMobile(this.loginParam.phone)) return;

      // 验证码判断
      if (this.loginParam.currentTab == 1 && !this.loginParam.code) {
        this.$Message.error('请输入验证码'); return;
      }

      // 账号密码判断
      if (this.loginParam.currentTab != 1 && !this.loginParam.password) {
        this.loginParam.code = null;
        this.$Message.error('请输入密码'); return;
      } else if (this.loginParam.currentTab != 1 && this.loginParam.password.length < 6) {
        this.$Message.error('请输入6位数字密码'); return;
      }

      // 数据处理
      let toLoginObj = ''
      if (this.loginParam.currentTab == 1) {
        toLoginObj = {
          cid: "",
          mobType: "",
          deviceno: "",
          isCaptcha: "1",
          captcha: this.loginParam.code,
          password: this.loginParam.code
        }
      } else {
        this.loginParam.code = null;  // 账号密码登录-移除验证码

        toLoginObj = {
          rememberMe: true,
          password: this.loginParam.password
        }
      }

      // 接口请求
      let preStatus = this.loginParam.currentStatus;
      this.loginParam.currentStatus = "loading";
      this.sendOther({
        url: '/web/auth/login/authc',
        data: Object.assign({
          subVersion: "2.1.0",
          loginType: "web",
          version: "3.0.0",
          isAutoLogin: "false",
          otherPlatform: true,
          userName: this.loginParam.phone
        }, toLoginObj),
      }, (result) => {
        this.$store.state.userId = result.data.data.userId;

        // 登录成功之后存储头像
        localStorage.setItem('headPhoto' + this.loginParam.phone, result.data.data.headPhoto);

        // local Store存储登录为true
        this.funLogin({
          ack: () => {
            _this.$Message.success("登录成功");
            _this.close_popups();  // 关闭弹框，并且初始化

            if (_this.$route.query.Rurl) {
              _this.$router.push({ path: _this.$route.query.Rurl });
            }

            // 查询是否参与成功登录的活动
            _this.activity(result.data.data.userId);
            _this.getTotals(); // 获取页面右侧导航栏的数据

          }
        });
      }, (result) => {
        // console.log("其他回调", result);
        // 登录失败
        this.loginParam.currentStatus = preStatus;
      })
    },
    // 注册
    registerEvent: function () {
      if (!this.verifyMobile(this.loginParam.phone)) return;
      if (!this.loginParam.registerParam.captcha) {
        this.$Message.error('请输入验证码'); return;
      }
      if (!this.loginParam.registerParam.password || !this.loginParam.registerParam.rePassword) {
        this.$Message.error('请输入密码'); return;
      } else if (this.loginParam.registerParam.password.length < 6 || this.loginParam.registerParam.rePassword.length < 6) {
        this.$Message.error('请输入6位数字密码'); return;
      }
      if (this.loginParam.registerParam.password != this.loginParam.registerParam.rePassword) {
        this.$Message.error('两次密码输入不一致'); return;
      }
      this.sendOther({
        url: '/web/mobuser/reg/success',
        data: {
          mobNumber: this.loginParam.phone,
          password: this.loginParam.registerParam.password,
          checkNumber: this.loginParam.registerParam.captcha,
          mobUserType: "01"
        }
      }, (result) => {
        this.$Message.success(result.data.message);
        // 如果有定时器则清除
        this.captchaTimer ? clearInterval(this.captchaTimer) : "";
        this.smsCaptcha.text = "获取验证码";
        this.smsCaptcha.enableClick = true;
        // 进入登录页面
        this.loginParam.currentStatus = "login";
        this.loginParam.currentTab = 2;
        /*// 调用账号密码登录
        this.loginParam.currentTab = 2;
        this.loginParam.password = this.loginParam.registerParam.password;
        this.loginEvent();*/
      })
    },
    // 重置密码
    resetPassword () {
      if (!this.verifyMobile(this.loginParam.phone)) return;
      if (!this.loginParam.forgetParam.captcha) {
        this.$Message.error("请输入验证码"); return;
      }
      if (!this.loginParam.forgetParam.password || !this.loginParam.forgetParam.rePassword) {
        this.$Message.error('请输入密码'); return;
      }
      if (this.loginParam.forgetParam.password != this.loginParam.forgetParam.rePassword) {
        this.$Message.error('两次密码输入不一致'); return;
      }
      this.sendOther({
        url: '/web/mobuser/reg/findPassword',
        data: {
          mobNumber: this.loginParam.phone,
          password: this.loginParam.forgetParam.password,
          checkNumber: this.loginParam.forgetParam.captcha,
        }
      }, (result) => {
        this.$Message.success(result.data.message);
        // 如果有定时器则清除
        this.captchaTimer ? clearInterval(this.captchaTimer) : "";
        this.smsCaptcha.text = "获取验证码";
        this.smsCaptcha.enableClick = true;
        // 进入登录页面
        this.loginParam.currentStatus = "login";
        this.loginParam.currentTab = 2;
        // 调用账号密码登录
        /*this.loginParam.currentTab = 2;
        this.loginParam.password = this.loginParam.forgetParam.password;
        this.loginEvent();*/
      })
    },
    // 退出登录
    exitLoginEvent: function () {
      console.log("退出登录")
      this.smsCaptcha.text = "获取验证码";
      this.smsCaptcha.enableClick = true;
      clearInterval(this.captchaTimer);
      this.close_popups();
      this.exitLogin();
    },
    headImage: function () {
      if (localStorage.getItem('headPhoto' + this.loginParam.phone)) {
        return this.getImgUrl(localStorage.getItem('headPhoto' + this.loginParam.phone));
      } else {
        return this.imgUrl('account/Avatar@2x.png');
      }
    },
    // 密码框失去焦点事件
    blurPass (e) {
      // e.target.value.length < 6 ? _this.$Message.error('请输入6位数字密码') : '';
    },

    // 红包活动
    redPacketActive: function () {
      // 红包处理
      if (_this.$store.state.redType == 1) {
        console.log('新用户', _this.$store.state.redType);
        // 新用户
        setTimeout(function () {
          console.log('setTimeout');
          _this.$store.state.showPopups = true;
          _this.$store.state.redStatus = true;
          _this.$store.state.redOldStatus = false;
          setTimeout(function () {
            _this.$store.state.drawDownStatus = false;
            _this.$store.state.drawUpStatus = true;
          }, 1000)
        }, 1000)
      } else if (_this.$store.state.redType == 2) {
        // 老用户
        console.log('老用户', _this.$store.state.redType);
        setTimeout(function () {
          console.log('setTimeout');
          _this.$store.state.showPopups = true;
          _this.$store.state.redOldStatus = true;
          _this.$store.state.redStatus = false;
          /*setTimeout(function () {
            _this.$store.state.drawDownOldStatus = false;
            _this.$store.state.drawUpOldStatus = true;
          }, 1000)*/
        }, 1000)
      }
    },
    // 获取老用户红包
    getOldRed: function () {
      _this.getRedAmount(_this.$store.state.redPkId);
    },
    // 去明细页面
    toServiceDetail: function () {
      _this.hidePopusClick();
      _this.$router.push('/ServiceChargeDetail');
    },
    // 展示老用户红包
    showOldRed: function () {
      _this.$store.state.showPopups = true;
      _this.$store.state.redOldStatus = true;
      _this.$store.state.drawDownOldStatus = true;
      _this.$store.state.drawUpOldStatus = false;
    },
    // 遮罩层点击隐藏弹框
    hidePopusClick: function () {
      console.log("hidePopus");
      if ((_this.$store.state.redOldStatus || _this.$store.state.redStatus)) {
        _this.$store.state.redOldStatus = false;
        _this.$store.state.redStatus = false;

        setTimeout(function () {
          _this.$store.state.showPopups = false;
          // 新用户红包弹框是否展示
          _this.$store.state.drawDownStatus = true;
          _this.$store.state.drawUpStatus = false;
          // 老用户红包弹框是否展示
          _this.$store.state.drawDownOldStatus = true;
          _this.$store.state.drawUpOldStatus = false;
        }, 500)
      }
    },
    // 链接跳转
    routerTo: function (type) {
      switch (type) {
        case 'DiscountTrends':
          _this.$router.push('/DiscountTrends');
          break;
        case 'order':
          if (_this.$store.state.orderCountYP > 0 || _this.$store.state.orderCountSP < 1) {
            _this.$router.push('/SilverTicket'); // 银票进行中的订单
          } else if (_this.$store.state.orderCountSP > 0) {
            _this.$router.push('/ProceedOrder'); // 商票进行中的订单
          }
          break;
      }
    },
    getTotals () {
      if (!localStorage.getItem("isLogin")) {
        return false;
      }
      let promise1 = new Promise((resolve, reject) => {
        this.sendOther({
          url: '/web/backlog/count',
          data: {
            userId: this.$store.state.userId,
            status: "unprocessed", // 待办事项状态：unprocessed	未处理；processed	已处理
          },
        }, (result) => {
          _this.$store.state.eventCount = result.data.data;
          resolve();
        }, result => {
          resolve();
        })
      });
      let promise2 = new Promise((resolve, reject) => {
        // 进行中的银票、商票数量
        this.sendGet({
          url: '/trade-center/discount-order-union/statistics/',
          data: {
            userId: _this.$store.state.userId,
            statisticsTypeArr: 'QUANTITY',
            status: 'PROCESS',
            entranceCode: 'FORE'
          },
        }, (result) => {
          resolve(result.data);
        }, (result) => {
          resolve(result.data);
        })
      });

      Promise.all([promise1, promise2]).then(values => {
        _this.$store.state.orderCount = values[1].data.totalQuantity;
        console.log(values[1].data);
        _this.$store.state.orderCountYP = values[1].data.bankOrderQuantity; // 银票
        _this.$store.state.orderCountSP = values[1].data.cpOrderQuantity; // 商票
      });
    },
  },

  created () {
    _this = this;

    // 刷新页面，先从存储中获取登录状态的值
    if (this.fungetLogin() && localStorage.getItem('loginParam')) {
      // 使用存储的loginParam的值
      // this.$store.state = JSON.parse(localStorage.getItem('loginParam')); // 这样使用是错误的
      for (let item in this.$store.state) {
        this.$store.state[item] = JSON.parse(localStorage.getItem('loginParam'))[item];
      }
      // 重新获取用户信息
      _this.getUserInfoMain(); // 获取用户信息

      _this.activity(_this.$store.state.userId);  // 获取是否领取红包信息

      _this.getTotals(); // 获取页面右侧导航栏的数据
    }
    this.hidePopus(); // 隐藏弹框

    if (!this.fungetLogin()) {
      // 未查询到用户，返回到登录
      if (this.$route.name == "BankSigning" || this.$route.name == "ServiceCharge" || this.$route.name == "IssueInvoice" || this.$route.name == "DiscountRecord") {
        this.$router.push('/home');
        console.log("to home")
      }
    }
  },
  watch: {
    "$route.params.login": function (nval, oval) {
      console.log("watch login", this.$route.params.login)
      if (this.$route.params.login && !this.fungetLogin()) { // 退出登录
        this.showLoginPopus();
      }
    },
    '$store.state.user.userInfo': {
      deep: true,
      handler: function (nval, oval) {
        // 监听用户代理人信息是否更改来判断是否展示代理人
        !nval.hasOwnProperty("discountAgent") ? this.$store.state.discountRouterIsShow = false : this.$store.state.discountRouterIsShow = true;
      },
    },
    $route (to, from) {
      console.log("获取最新的服务费");
      this.getUserInfoMain(); // 获取最新的服务费
      this.getTotals(); // 获取页面右侧导航栏的数据
      this.$store.state.redType ? '' : (this.$store.state.userId ? this.activity(this.$store.state.userId) : ''); // 如果当前没有红包则判断当前用户是否有红包

      if (this.isIos()) {
        document.getElementById('body').style.minHeight = "2300px";
      }
    }
  },

  computed: {
    sessionIsLogin () {
      return this.fungetLogin()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/base.less';

// 公共主题使用的样式
// 主要中心宽度
.main_width {
  width: 1190px;
}
.min_main_width {
  min-width: 1230px;
}
.min_width {
  min-width: 1190px;
}
@media only screen and (max-width: 1230px) {
  body {
    width: 1230px;
  }
}

.ivu-menu-horizontal.ivu-menu-light:after {
  background: none !important;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover {
  border-width: 3px;
}

.login_alert_left {
  background: linear-gradient(
    180deg,
    rgba(0, 42, 126, 0.88),
    rgba(255, 255, 255, 0)
  );
}
.login_alert .ivu-input {
  border: none !important;
}
.login_alert .ivu-input:focus {
  box-shadow: none;
}
.login_btn_style {
  background: linear-gradient(232deg, rgba(246, 1, 81, 1), rgba(96, 0, 255, 1));
  border: none;
  width: 80px;
}
.login_btn_style:hover {
  /*background: #2db7f5;*/
}
.hide {
  width: 0;
  position: absolute;
  opacity: 0;
}
.login_logo {
  background-size: cover;
  background-position: top center;
  background: url(~@/assets/img/home/ktb_phto@2x.png) no-repeat bottom center;
}
.fixedTop {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
  width: 100%;
}
/*登录头像*/
.head_img {
  border-radius: 50%;
  background: url(~@/assets/img/account/Avatar@2x.png) no-repeat center top;
  background-size: cover;
}

.main_top_nav > span:hover,
.main_top_nav p:hover,
.main_top_nav a:hover,
.main_top_nav a:hover svg,
.main_top_nav a:hover i {
  color: #333 !important;
}

/*客服*/
.ivu-badge-count_n {
  -webkit-box-shadow: 0 0 0 1px #ff3300 !important;
  box-shadow: 0 0 0 1px #ff3300 !important;
}
.main_custom {
  position: fixed;
  bottom: 140px;
  right: 30px;
  z-index: 99999;
  background-color: #1989e8;
  cursor: pointer;
  padding: 0 3px;

  p {
    height: 34px;
    line-height: 34px;
    color: #fff;
    padding: 0px 20px 0px 10px;
    border-right: 1px solid #cf3830;
  }
  span {
    display: inline-block;
    border-radius: 3px;
    width: 34px;
    height: 40px;
    line-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .left_tip:hover::after {
    content: '';
    position: absolute;
    width: 125px;
    line-height: 40px;
    background-color: rgba(51, 51, 51, 0.8);
    border-radius: 10px;
    right: 34px;
    top: 0px;
  }
  .left_tip:hover::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    right: 16px;
    border: 9px solid transparent;
    border-left-color: rgba(51, 51, 51, 0.8);
  }
  .left_tip_trial:hover::after {
    content: '贴现计算器';
  }
  .left_tip_line:hover::after {
    content: '行号查询';
  }
  .left_tip_backlog:hover::after {
    content: '待办事项';
  }
  .left_tip_ordering:hover::after {
    content: '进行中的订单';
  }
  .left_tip_customer:hover::after {
    content: '联络在线客服';
  }
}

/*红包*/
.red_packet {
  width: 696px;
  height: 584px;
  position: absolute;
  top: 50%;
  margin-top: -292px;
  left: 50%;
  margin-left: -348px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  border-radius: 22px;
  animation: red-packet-in2 0.5s ease;

  .draw-down {
    width: 100%;
    height: 176px;
    background: url(~@/assets/img/img_red_packet/Red_envelope_head@2x.png)
      no-repeat center center;
    background-size: cover;
    position: relative;
    bottom: -88px;
  }
  .bottom {
    height: 367px;
    background: url(~@/assets/img/img_red_packet/Red_envelope_body@2x.png)
      no-repeat center center;
    background-size: cover;
    z-index: 1;

    .search_red {
      position: absolute;
      bottom: 67px;
      color: #e56750;
      width: 238px;
      height: 54px;
      background: #ffe2b1;
      border-radius: 27px;
      font-size: 24px;
      left: 50%;
      margin-left: -119px;
      z-index: 1;

      .search_red_icon {
        width: 21px;
        height: 27px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 12px;
        background: whitesmoke;
      }
    }

    .search_red:hover {
      opacity: 0.9;
    }
  }

  .draw-up {
    width: 100%;
    height: 550px;
    background: url(~@/assets/img/img_red_packet/Red_envelope@2x.png) no-repeat
      center center;
    background-size: cover;
    position: absolute;
    overflow: hidden;
    top: 40px;

    .draw-slow-up {
      width: 694px;
      height: 423px;
      background: url(~@/assets/img/img_red_packet/paper@2x.png) no-repeat
        center center;
      background-size: cover;
      position: relative;
      top: -72px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
  }

  /*老用户红包*/
  .draw-down-old {
    background: url(~@/assets/img/img_red_packet/Red_envelope_head_Sleek@2x.png)
      no-repeat center center;
  }
  .bottom-old {
    background: url(~@/assets/img/img_red_packet/Red_envelope_body_Sleek@2x.png)
      no-repeat center center;
    height: 352px;

    .down_bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .click_btn {
        width: 158px;
        height: 158px;
        font-size: 64px;
        font-weight: bold;
        color: #ffe2b1;
        background-color: #e56750;
        border-radius: 50%;
        line-height: 158px;
        cursor: pointer;
        margin-bottom: 51px;
      }
    }
  }
  .draw-up-old {
    background: url(~@/assets/img/img_red_packet/Red_envelope_y@2x.png)
      no-repeat center center;

    /*老用户红包*/
    .draw-slow-up-old {
      background: url(~@/assets/img/img_red_packet/paper@2x.png) no-repeat
        center center;
    }
  }
}

@keyframes red-packet-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes red-packet-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0);
    /*margin-top: 80px;
        margin-left: 300px;*/
    top: 100%;
    left: 100%;
  }
}

@keyframes red-packet-in2 {
  0% {
    opacity: 0;
    top: 100%;
    left: 100%;
  }
  100% {
    opacity: 1;
  }
}

@keyframes draw-up-in {
  0% {
    opacity: 0;
    bottom: -285px;
  }
  100% {
    opacity: 1;
    bottom: 0px;
  }
}

@keyframes open-in {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.9);
  }
}

.red-packet-enter-active {
  animation: red-packet-in2 0.5s ease;
}
.red-packet-leave-active {
  animation: red-packet-out 0.5s ease;
}

.draw-up-enter-active {
  animation: draw-up-in 0.5s ease;
}
.draw-down-leave-active {
  animation: red-packet-in 0.5s reverse;
}

.red-button-enter-active {
  animation: red-packet-in 0.5s ease;
}

.open-face-enter-active {
  animation: open-in 0.2s linear 0.5s infinite alternate;
  animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
}

/* 红包小图标 */
.red_packet_small {
  width: 112px;
  height: 72px;
  position: fixed;
  bottom: 60px;
  right: 30px;
  background: url(~@/assets/img/img_red_packet/Small_red_envelope@2x.png)
    no-repeat center center;
  background-size: cover;
  cursor: pointer;
  z-index: 1;
}

#YSF-BTN-HOLDER {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue